<template>
  <div>
    <v-layout text-xs-center wrap>
      <v-flex>
        <Title title="Mes scores"/>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 offset-sm1 sm10 offset-md1 md10 lg8 offset-lg2 xl6 offset-xl3>
        <History :scores="scores"/>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import History from '@/components/molecules/History.vue';
  import Title from '@/components/atoms/Title';

  export default {
    components: { History, Title },
    props: ['scores'],
  };
</script>
